export class DiamondShape {
  constructor(public name: string, public shapeNameIcon?: string) {
    this.name = name;
    this.shapeNameIcon = `diamondShape${shapeNameIcon ?? name}`;
  }
}
